import { Component, Input, OnChanges } from '@angular/core';
import { SelectBoxConfig } from '../../models/select-box-config.model';

@Component({
  selector: 'app-select-box',
  templateUrl: './select-box.component.html',
  styleUrls: ['./select-box.component.scss']
})
export class SelectBoxComponent implements OnChanges {
  @Input() config!: SelectBoxConfig;

  currentErrorMessage: string | undefined;

  ngOnChanges(): void {
    this.currentErrorMessage = this.config?.errorMessage;
  }

  onSelectionChange(value: any): void {
    this.currentErrorMessage = undefined;
    if (this.config?.onValueChange) {
      this.config.onValueChange(value);
    }
  }
}